/* global require */

'use strict';

require('../css/ui-notice.css');

var directives = require('./directives');

directives.createPopup('notice', {
    template: '<div class="ui-popup">' +
        '<div class="ui-notice" ng-transclude>' +
        '</div>' +
        '</div>'
});


//////////////////
// WEBPACK FOOTER
// ./src/directives/notice.js
// module id = 12
// module chunks = 0